import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationSandbox, ConfigService } from '@hohr/config';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, EMPTY, combineLatest } from 'rxjs';
import { first, mergeMap } from 'rxjs/operators';
import { AppFacade } from './app.facade';
import { ProfileService } from './core/services/profile.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'cv-builder';
  isThemeChanged$ = new BehaviorSubject<boolean>(false);

  get isErrorPageRoute() {
    return this.router.url === '/error';
  }

  constructor(
    private translateService: TranslateService,
    public authSandbox: AuthenticationSandbox,
    public router: Router,
    private configService: ConfigService,
    public profileService: ProfileService,
    public appFacade: AppFacade
  ) {}

  ngOnInit() {
    if (!this.configService.config) {
      this.router.navigate(['error']);
    } else {
      this.setAuthListener();
      this.setupTranslateService();
      this.appFacade.getMyProfileUri().subscribe();
    }
  }
  private setupTranslateService() {
    const cultures = this.configService.config.cultures;
    const localStorageLanguage = localStorage.getItem('appLanguage');

    if (
      !localStorageLanguage ||
      !cultures.some(
        (lang) =>
          lang.cultureCode.toLowerCase() === localStorageLanguage?.toLowerCase()
      )
    ) {
      this.appFacade.setCurrentCulture(cultures[0]);
    } else {
      this.appFacade.setDefaultLanguage(localStorageLanguage);
    }

    this.translateService.addLangs([
      ...cultures.map((lang) => lang.cultureCode),
    ]);
  }

  themeChange(hasError) {
    if (hasError) {
      this.router.navigate(['error']);
    }

    this.isThemeChanged$.next(true);
  }

  setAuthListener() {
    this.authSandbox.authenticated$
      .pipe(
        first(),
        mergeMap((isAuth: boolean) => {
          if (isAuth) {
            return combineLatest([
              this.appFacade.getUserProfile(),
              this.appFacade.getProfilePhoto(),
            ]);
          }
          return EMPTY;
        })
      )
      .subscribe();
  }
}
